import { GENERATE_POST } from "../configs/routes.js";
import api from "./api.js";

export const generatePost = (payload) =>
    new Promise((resolve, reject) => {
        api
            .post(GENERATE_POST, payload, { timeout: 120000 })
            .then((response) => resolve(response.data))
            .catch((err) => reject(err));
    });
